import { Children } from "react";

import './fullingredientlist.css';

export default function FullIngredientsModal({isOpen,setOpen,children}) {

  if( isOpen ) {
    return (
        <div className="fullingredientlist-container">
          <div className="fullingredientlist-fullingredientlist">
            <div className="fullingredientlist-frame376">
              <div className="fullingredientlist-frame70">
                <div className="fullingredientlist-frame67">
                  <span className="fullingredientlist-text1 MOBILEHEADLINE">
                    <span>Full ingredient list</span>
                  </span>
                </div>
                <span className="fullingredientlist-text3">
                  <span>
                    ALCOHOL DENAT., AQUA/WATER/EAU, PARFUM/FRAGRANCE,
                    BUTYL METHOXYDIBENZOYLMETHANE, LINALOOL, LIMONENE, ALCOHOL,
                    CITRAL, TRIS(TETRAMETHYLHYDROXYPIPERIDINOL) CITRATE,
                    CITRONELLOL, EUGENOL, CINNAMAL, GERANIOL, BENZYL BENZOATE,
                    YELLOW 5 (CI 19140), BLUE 1 (CI 42090).
                  </span>
                </span>
              </div>
            </div>
            <img
              alt="image273977"
              src="/external/back-btn.svg"
              className="fullingredientlist-image27"
              onClick={() => setOpen(false)}
            />
          </div>
        </div>
    );
  }
  return( children );
};